import { GET_REQUEST } from '@/services/http';
import apiPath from '@/services/apiPath';

export function encryptWithRSA (publicKeyPem, value){
  var forge = require('node-forge');
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem)
  return forge.util.encode64(publicKey.encrypt(value, 'RSA-OAEP'));
};

export async function groupEncryptWithRSA (value){
  if(!value) return;
  let key = await getPublicKey();
  return new Promise((result, failed) => {
    setEncryptWithRS(key, value).then(
      (success) => {
        result(success);
      }
    );
  });
};

async function getPublicKey(){
  let key = null;
  const path = `${apiPath.PUBLIC_KEY}`;
  await GET_REQUEST(path).then(
  (success) => {
    const resultData = success.data;
    key = `-----BEGIN PUBLIC KEY-----${resultData.key}-----END PUBLIC KEY-----`;
  }, (failed) => {
    store.dispatch('commonToast/fetchToastStart', failed.msg);
  })
  return key;
}

function setEncryptWithRS(key, value){
  return new Promise((success, failed) => {
    if(!value) return;
    let result = value;
    const valuekeyArray = Object.keys(value);
    valuekeyArray.forEach((valuekey) => {
      result[valuekey] = encryptWithRSA(key, result[valuekey]);
    });
    success(result);
  });
}